import muxPluginIds from "../../../shared/mux-plugin-ids.json";
import { MUX_NO_PLUGIN_ID } from "./mux";

type MuxPluginIdsJson = {
  version: number;
  reserved: {
    core: number;
    none: number;
  };
  plugins: Record<string, number>;
  toolPrefixes?: Record<string, string>;
};

const source = muxPluginIds as MuxPluginIdsJson;
const plugins = source.plugins;
const toolPrefixes = source.toolPrefixes ?? {};

export const MUX_PLUGIN_IDS_VERSION = source.version;
export const MUX_CORE_PLUGIN_NUMERIC_ID = source.reserved.core;
export const MUX_NONE_PLUGIN_NUMERIC_ID = source.reserved.none;

export function muxPluginNumericId(pluginId: string | null | undefined): number {
  if (!pluginId) return MUX_NO_PLUGIN_ID;
  const value = plugins[pluginId.toLowerCase()];
  return Number.isInteger(value) && value >= 0 && value <= 0xffff ? value : MUX_NO_PLUGIN_ID;
}

export function muxPluginIdForTool(toolName: string): string | null {
  const firstPart = toolName.split("_", 1)[0]?.toLowerCase() ?? "";
  if (!firstPart) return null;
  if (Object.prototype.hasOwnProperty.call(plugins, firstPart)) return firstPart;
  const aliasedPluginId = toolPrefixes[firstPart]?.toLowerCase();
  return aliasedPluginId && Object.prototype.hasOwnProperty.call(plugins, aliasedPluginId) ? aliasedPluginId : null;
}

export function muxPluginNumericIdForTool(toolName: string): number {
  return muxPluginNumericId(muxPluginIdForTool(toolName));
}

export function muxKnownPluginIds(): string[] {
  return Object.keys(plugins).sort();
}
